require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2014-06-20-rackspace-onmetal-launched.json") })
        }
      }, "path---articles-2014-06-20-rackspace-onmetal-launched");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2014-06-20-rackspace-onmetal-launched!./.cache/json/articles-2014-06-20-rackspace-onmetal-launched.json
// module id = 627
// module chunks = 231608221292675